<div class="card obras-por-tarefas-card p-4">
  <h5 class="card-title">Obras por Tarefas</h5>

  <div class="filtros d-flex mb-4">
    <app-filtro-responsavel
      [responsavel]="responsavel"
      [(filtroResponsavel)]="selectedUsuario"
      (responsavelIdChange)="onResponsavelIdChange($event)"
      (responsavelLimpo)="onResponsavelIdChange(0)"
      (responsaveisChange)="onResponsaveisRecebidos($event)"
    ></app-filtro-responsavel>

    <app-filtro-periodo
      [(intervaloSelecionado)]="selectedPeriodo"
      [config]="config"
      (intervaloSelecionadoChange)="onPeriodoSelecionadoChange($event)"
    ></app-filtro-periodo>

    <app-filtro-acoes
      [acoes]="acoes"
      [(filtroAcoesSelecionados)]="selectedAcoes"
      (limpaAcoes)="onAcoesSelecionadasChange()"
      (filtroAcoesSelecionadosChange)="onAcoesSelecionadasChange()"
    ></app-filtro-acoes>

    <app-filtro-tipo-obra
      (tiposSelecionadosChange)="onTiposSelecionadosChange($event)"
    ></app-filtro-tipo-obra>

    <button type="button" class="btn btn-dark" (click)="exportExcel()" [disabled]="desabilitarExportar">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/agenda-tarefas/download.svg"
        width="20"
        height="20"
        alt=""
      />
      EXPORTAR
    </button>
  </div>
  <div class="view-switch d-flex justify-content-between mb-4">
    <div class="d-flex">
      <button
        type="button"
        class="btn btn-visao-geral"
        [ngClass]="{
          'btn-dark': viewMode === 'chart',
          'btn-outline-secondary': viewMode !== 'chart'
        }"
        (click)="toggleView('chart')"
      >
        <img
          src="{{
            BASE_IMG_URL
          }}assets/agenda-tarefas/grafico-de-pizza.png"
          width="16"
          height="16"
          alt=""
        />
        Visão Geral
      </button>
      <button
        type="button"
        class="btn"
        [ngClass]="{
          'btn-dark': viewMode === 'table',
          'btn-outline-secondary': viewMode !== 'table'
        }"
        (click)="toggleView('table')"
      >
        <img
          src="{{ BASE_IMG_URL }}assets/agenda-tarefas/table.svg"
          width="16"
          height="16"
          alt=""
        />
        Visão por Obras
      </button>
    </div>
  </div>
  @if ( arrObrasPorTarefa.length > 0 ) {
  <div
    class="grafico-apex row align-items-center justify-content-center"
    *ngIf="viewMode === 'chart'"
  >
    <div class="grafico-legenda-flex">
      <div class="grafico-pizza">
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [labels]="chartOptions.labels"
          [colors]="chartOptions.colors"
          [plotOptions]="chartOptions.plotOptions"
          [tooltip]="chartOptions.tooltip"
          [legend]="chartOptions.legend"
          [responsive]="chartOptions.responsive"
        ></apx-chart>
      </div>
      <div
        class="custom-legend-table"
        *ngIf="chartOptions.series?.length && chartOptions.labels?.length"
      >
        <table>
          <thead>
            <tr>
              <th>Legenda</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let label of chartOptions.labels; let i = index">
              <td>
                <span
                  class="color-dot"
                  [ngStyle]="{ background: chartOptions.colors[i] }"
                ></span>
                {{ label }}
              </td>
              <td>{{ chartOptions.series[i] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  }

  <div
    *ngIf="arrObrasPorTarefa.length === 0 && tableData.length === 0"
    class="no-results"
  >
    Não há resultados para os filtros selecionados.
  </div>

  @if (tableData.length > 0) {
  <div
    class="table-container table-responsive"
    *ngIf="viewMode === 'table' && tableData.length > 0"
  >
    <app-tabela-paginacao
      [columns]="columns"
      [data]="tableData"
      (workNameClick)="onWorkNameSelected($event)"
      (companyNameClick)="onCompanyNameClick($event)"
      [trackByFn]="trackByFn"
      [pagination]="{
        page: currentPage,
        pageFirst: 1,
        pageLast: totalPages,
        pageNext: currentPage < totalPages ? currentPage + 1 : null,
        pagePrev: currentPage > 1 ? currentPage - 1 : null,
        recordsCount: tableData.length,
        pageActive: true,
        pageSize: 10,
        shortcuts: 0,
        hasValue: tableData.length > 0,
        shortcutPages: [],
        records: tableData
      }"
      (paginaMudada)="mudarPagina($event)"
    ></app-tabela-paginacao>
  </div>
  }
</div>

<app-modal-aguardando-download
  *ngIf="processandoAcao"
  [mensagem]="mensagemProcessando"
></app-modal-aguardando-download>
